
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox } from "cbc-shared-lib";
import { CodeConversionMstDto } from 'sg-api';

@Component({
  selector: 'app-sgke090d-condition',
  templateUrl: './sgke090d-condition.component.html',
  styleUrl: './sgke090d-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke090dConditionComponent implements OnInit, OnDestroy {
  /** コードマスタ取得 */
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 業務日付 */
  @Input() businessDate: Date = null;

  /** クリアボタン押下イベント */
  @Output() onClickClearEvent = new EventEmitter();

  /** 業務リスト */
  gyomShubetuList: SelectBox[] = [];

  /** ステータスリスト */
  approvalList: SelectBox[] = [];

  /** 検索条件FormGroup */
  searchConditionForm: UntypedFormGroup;

  /** 親コンポーネントFormGroup */
  private parentForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb
   * @param {FormGroupDirective} parent
   * @memberof Sgke090dConditionComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private cd: ChangeDetectorRef,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke090dConditionComponent
   */
  ngOnInit() {
    this.searchConditionForm = this.fb.group({
      apprvreqYearmonthdateStart: [{ value: null, disabled: false }],
      apprvreqYearmonthdateEnd: this.fb.nonNullable.control({ value: this.businessDate, disabled: false }, Validators.required),
      kinkoGyomuclsfyCodelst: this.fb.nonNullable.control({ value: ['3', '2', '5', '7'], disabled: false }, Validators.required),
      kinkoApprovalstatusCodelst: this.fb.nonNullable.control({ value: ['3'], disabled: false }, Validators.required),
    });

    this.parentForm = this.parent.form;
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("samplingCndt", this.searchConditionForm);

    // 対象プロパティが変更された場合のみ処理する
    if (this.codeConversionMstMap) {
      // コード値毎のkeyに対して、userCode(セレクトボックスの値)、hyojiCont(セレクトボックスの表示文字)がサービスから設定されているので、それを取得する
      this.gyomShubetuList.push(...this.getSelectBoxFromCodeConversionMst('S300471'));
      this.approvalList.push(...this.getSelectBoxFromCodeConversionMst('S100033'));
    }
    this.cd.detectChanges();
  }

  /**
   * 購読解除
   * @memberof Sgke090dConditionComponent
   */
  ngOnDestroy() {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('samplingCndt');
  }

  /**
   * UntypedFormControl取得
   * @param {*} ctrlName
   * @return {*}  {UntypedFormControl}
   * @memberof Sgke090dConditionComponent
   */
  getControl(ctrlName): UntypedFormControl {
    return this.searchConditionForm.get(ctrlName) as UntypedFormControl;
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke090dConditionComponent
   */
  onClickClear() {
    // 入力内容をクリアする
    this.searchConditionForm?.reset();
    this.onClickClearEvent.emit();
  }

  /**
  * コードIDに対応するコード変換マスタ値をSelectBoxの配列で戻す
   * @param {string} codeId
   * @return {*}  {SelectBox[]}
   * @memberof Sgke090dConditionComponent
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let retSelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          retSelectBoxList.push(select);
        })
      }
    }
    return retSelectBoxList;
  }
}
